module.exports = __webpack_public_path__ + "static/media/ddAudio.31e2566.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ddAudio.mp3
// module id = 56RZ
// module chunks = 12